import { Text } from '@myinterview/component-library';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const PracticeMode:React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="myinterview-widget__practice-mode">
      <Text size="S-Regular" color="primary">{t('practice.title')}</Text>
    </div>
  );
};
